
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant'
import { ImagePreview } from 'vant'

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.photoReports,
    components: {
        ImagePreview
    },
    data () {
        return {
            id: '',
            title: '图集',
            imgsInfo: {}
        }
    },
    computed: {
        ...mapState({
            photoReportsState: ({ photoReports }) => photoReports
        }),
    },
    created () {
        const { id } = this.$route.query
        this.id = id
    },
    activated () { },
    mounted () {
        this.setTitle()
        this.showLoading()
        this.getMarketingInfoImgs(this.id).then(res => {
            if (res.photo_atlas && res) {
                this.imgsInfo = res
            } else {
                this.$dialog.alert({
                    title: '提示',
                    message: '没有图集，请稍后重试'
                }).then(() => {
                    this.$router.replace({
                        path: '/'
                    })
                })
            }
        }).catch(_ => {
            this.$dialog.alert({
                title: '提示',
                message: '没有图集，请稍后重试'
            }).then(() => {
                this.$router.replace({
                    path: '/'
                })
            })
        })
        this.hideLoading()
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getMarketingInfoImgs'
        ]),
        setTitle () {
            this.$emit('setHeader', {
                title: this.title,
                showHeader: true,
                showLeft: true
            })
            this.setAppClass({
                isAppend: false,
                className: 'bgWhiteColor'
            })
            document.title = this.title
        },
        newImagePreview (index) {
            ImagePreview({
                images: this.imgsInfo.photo_atlas,
                startPosition: index,
                // showIndicators: true,
                lazyLoad: true,
                maxZoom: 2,
                minZoom: 1 / 2,
                onClose () {
                    // do something
                }
            })
        }
    },
}
